import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useHashScroll = () => {
  const location = useLocation();

  useEffect(() => {
    const handleHashScroll = () => {
      const hash = location.hash;
      if (hash) {
        const elementId = hash.substring(1); // Remove o #
        console.log('Tentando fazer scroll para:', elementId);
        
        // Função para tentar fazer scroll
        const tryScroll = (delay = 0) => {
          setTimeout(() => {
            const element = document.getElementById(elementId);
            if (element) {
              console.log('Elemento encontrado, fazendo scroll');
              // Calcula a posição considerando o header fixo
              const headerHeight = 80; // Altura aproximada do header
              const elementPosition = element.offsetTop - headerHeight;
              
              window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
              });
            } else {
              console.log('Elemento não encontrado, tentando novamente em:', delay + 500, 'ms');
              if (delay < 2000) {
                // Tenta novamente se o elemento ainda não foi encontrado
                tryScroll(delay + 500);
              }
            }
          }, delay);
        };

        // Inicia a tentativa de scroll
        tryScroll();
      }
    };

    // Executa sempre que a location mudar (incluindo mudanças no hash)
    handleHashScroll();
  }, [location]);
}; 